import { Grid, Tab, Tabs, Typography } from "@mui/material";
import { Link, Route, Switch, Redirect } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useRouteMatch } from "../../../../Helpers/RouteMatcher";
import { OrganisationAtom } from "../../../../State/Organisation.Atom";
import { MersetaLAIAttendees } from "../../Attendees/MersetaLAIAttendees";
import { MerSetaLaiTrainingPage } from "./LAI/MerSetaLaiTrainingPage";
import { InterventionAtom } from "./Intervention.Atom";
import { AncillaryCostsPage } from "./AncillaryCosts/AncillaryCostsPage";
import { TrainingTypes } from "../../../../Component/Model/Enum/BEE123Enums";
import { BreadCrumb } from "../../../../Component/Common/Components/BreadCrumb/BreadCrumb";


export const LAITrainingLandingPage = () => {
    const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);

    const routes = [
        `/organisation/training/LAI/form/Details`,
        `/organisation/training/LAI/form/Attendees`,
        `/organisation/training/LAI/form/AncillaryCosts`
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    const selectedLAI = useRecoilValue(InterventionAtom);
    const LAIExists = selectedLAI.id > 0;

    return (
        <>
            <BreadCrumb
                titles={['Manage Training', `LAI's`, 'Intervention']}
                hrefs={['/organisation/training/External', '/organisation/training/LAI', '']}
                currentLinkIndex={2}
            />

            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                {!LAIExists ? "Capture" : "Edit"} Learnerships, Apprenticeships or Internships
            </Typography>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Intervention Details" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Attendees" value={routes[1]} to={routes[1]} component={Link} disabled={!LAIExists} />
                        <Tab label="Ancillary Costs" value={routes[2]} to={routes[2]} component={Link} disabled={!LAIExists} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <MerSetaLaiTrainingPage />
                        </Route>
                        <Route path={routes[1]}>
                            <MersetaLAIAttendees organisationId={+peopleAndTrainingOrganisation.OrganisationId} organisationName={peopleAndTrainingOrganisation.OrganisationName} />
                        </Route>
                        <Route path={routes[2]}>
                            <AncillaryCostsPage interventionType={TrainingTypes.LAI} />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}